import React from 'react'
import cookie from 'isomorphic-cookie'
import { darken } from 'polished'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import useModalManager from '~/hooks/use-modal-manager'
import useVendor from '~/hooks/use-vendor'
import Button from '~/truck/button'
import Label from '~/truck/label'
import Overlay from '~/truck/overlay'
import theme from '~/truck/theme'
import { cloudinary, redirectTo } from '~/utils'
import { cookieNames, transformations } from '~/utils/constants'

import Modal from '../modal'

const StyledModal = styled(Modal.Standalone)`
  align-items: center;
  background-color: ${props => props.theme.colors.primary};
  height: auto;
  margin: auto 0;
  overflow-y: hidden;
  padding: ${theme.spacing.cozy * 6}px ${theme.spacing.relaxed}px;
  padding-bottom: ${theme.spacing.cozy * 7}px;

  > img {
    margin-bottom: ${theme.spacing.comfortable}px;
  }

  ${up('lg')} {
    padding: ${theme.spacing.cozy * 10}px ${theme.spacing.cozy * 15}px;
  }
`

const StyledOverlay = styled(Overlay)`
  display: flex;
  padding: 0 ${theme.spacing.comfortable}px;
`

const StyledImage = styled.img`
  height: ${theme.spacing.cozy * 12}px;
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${theme.spacing.cozy * 4}px;
  width: 100%;

  > :first-child {
    border: 1px solid ${props => props.theme.colors.white};
    margin-right: ${theme.spacing.comfortable}px;
  }

  > :last-child:hover {
    background-color: ${props => darken(0.05, props.theme.colors.primary)};
  }

  > * {
    flex-basis: 50%;
  }

  ${up('lg')} {
    > * {
      flex-basis: ${theme.spacing.cozy * 22.5}px;
    }
  }
`

const LegalAgeModal = props => {
  const { closeModal } = useModalManager()

  const vendor = useVendor()

  const logoUrl = cloudinary.applyTransformations(vendor.logo, transformations.LOGO)

  const deny = () => {
    redirectTo('/terminos-y-condiciones')

    closeModal(props.modalId)
  }

  const accept = () => {
    cookie.save(cookieNames.LEGAL_AGE_MODAL_CLOSED, 1, {
      secure: false,
    })

    closeModal(props.modalId)
  }

  return (
    <StyledOverlay open>
      <StyledModal>
        <StyledImage alt={vendor.name} src={logoUrl} />
        <Label $color="white" $textStyle="h3Semibold" as="p" $textAlign="center">
          ¡Bienvenido a {vendor.name}!
        </Label>
        <Label $color="white" $textStyle="h4Regular" as="p" $textAlign="center">
          ¿Eres mayor de 18 años?
        </Label>
        <ButtonsContainer>
          <Button type="button" onClick={deny}>
            No
          </Button>
          <Button.Ghost type="button" onClick={accept}>
            Sí
          </Button.Ghost>
        </ButtonsContainer>
      </StyledModal>
    </StyledOverlay>
  )
}

export default LegalAgeModal
